import * as React from "react";

import { asString, loadedDefinedMapWithDefault } from "common/components/component-helpers";
import { LOADING } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import { definedMapWithDefault } from "collection-utils";
import OverlayEditor from "../ui/smart/overlay-editor/overlay-editor";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

export const OverlayEditorMaterialRenderer: GlideFunctionalRenderer = p => {
    const { getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[valuePV, placeholderPV], [valueProducer]] = useForceValueProducers(getValueProducers, force, ctx);

    const onChange = React.useCallback(
        (newValue: string): void => {
            if (valueProducer === undefined) return;
            valueProducer.set(newValue);
        },
        [valueProducer]
    );

    if (valuePV === LOADING) {
        return null;
    }

    const value = definedMapWithDefault(valuePV, "", asString);
    const placeholder = loadedDefinedMapWithDefault(placeholderPV, "", asString);

    return <OverlayEditor value={value} placeholder={placeholder} onChange={onChange} />;
};
